import Dexie from "dexie";

export const db = new Dexie('Vendas');

db.version(1).stores({
  Cache: '++id, json', // Primary key and indexed props
});
